<h2>{{ arcFormula.Descr }}</h2>

<div class="form-group col-sm-3">
  <label>{{ 'revenue.arc.descr' | translate | titlecase }}</label
  ><br />
  <input class="form-control" type="text" [(ngModel)]="arcFormula.Descr" />
</div>
<div style="clear: both"></div>

<div class="form-group col-sm-3">
  <label>{{ 'revenue.arc.revenue-item' | translate | titlecase }}</label>
  <br />
  <select class="form-control" [(ngModel)]="arcFormula.ItemNum">
    <option value="-1">--{{ 'common.select-one' | translate | titlecase }}--</option>
    <option *ngFor="let revenueItem of revenueItems" [value]="revenueItem.ItemNum">{{ revenueItem.ItemName }}</option>
  </select>
  <div [hidden]="!showFormulaField">
    <br />
    {{ 'revenue.arc.formula' | translate | ucfirst }}
  </div>
</div>
<div [hidden]="showFormulaField" class="form-group">
  <div class="form-row col-sm-12" style="margin-top: 20px">
    <div class="col-sm-12" style="background-color: #f2f2f2; padding: 4px 0 4px 10px">
      <div class="col-sm-3" style="padding-left: 0px">
        <p-select
          appendTo="body"
          placeholder="{{ 'revenue.arc.field-placeholder' | translate | ucfirst }}"
          [(ngModel)]="selectedField"
          [options]="fieldList"
          (onChange)="selectedFieldTypeChange()"
          [disabled]="arcBuilderRows.length > 0"
          optionLabel="FieldName"
          styleClass="w-100"
        >
        </p-select>
      </div>
      <div class="col-sm mt-10 t-ar">
        <a [hidden]="!showFormulaToggle" (click)="toggleFormulaField()">{{ 'revenue.arc.use-custom-sql' | translate }}</a>
      </div>
    </div>
  </div>
  <div class="form-row col-sm-12" *ngFor="let row of arcBuilderRows; let i = index">
    <div
      *ngIf="!row.IsDefault"
      class="col-sm-3"
      style="padding-left: 0; display: inline-flex; align-items: center; justify-content: center"
    >
      <div class="col-sm"></div>
      <div class="col-sm-5">
        <input type="number" [(ngModel)]="row.RangeStart" [minValue]="0" [step]="1" class="form-control" style="padding: 0 0 0 2px" />
      </div>
      <div class="col-sm-1" style="text-align: center; padding: 10px 0">to</div>
      <div class="col-sm-5">
        <input type="number" [(ngModel)]="row.RangeEnd" [minValue]="0" [step]="1" class="form-control" style="padding: 0 0 0 2px" />
      </div>
    </div>
    <div *ngIf="row.IsDefault" class="col-sm-3" style="display: inline-flex; align-items: center; justify-content: center; height: 3.5rem">
      <span>{{ 'revenue.arc.default-case' | translate }}</span>
    </div>
    <div class="col-sm-8" style="display: inline-flex; align-items: center">
      <span>{{ 'common.revenue.price' | translate | titlecase }} is ( {{ selectedField.FieldName }} x </span>&nbsp;
      <div class="input-group col-sm-2">
        <wl-currency-symbol class="input-group-addon"></wl-currency-symbol
        ><input
          type="number"
          [(ngModel)]="row.MultiplierPrice"
          [minValue]="0.0"
          [step]="0.01"
          class="form-control"
          style="padding: 0 0 0 2px"
        />
      </div>
      &nbsp; <span>) + </span>&nbsp;
      <div class="input-group col-sm-2">
        <wl-currency-symbol class="input-group-addon"></wl-currency-symbol
        ><input type="number" [(ngModel)]="row.BasePrice" [minValue]="0.0" [step]="0.01" class="form-control" style="padding: 0 0 0 2px" />
      </div>
    </div>
    <div *ngIf="!row.IsDefault" class="col-sm-1 pull-right">
      <button pButton type="button" class="btn btn-small btn-primary" icon="pi pi-times" (click)="removeRow(i)"></button>
    </div>
    <div class="w-100"></div>
  </div>
  <div class="form-row col-sm-12" *ngIf="arcBuilderRows.length > 0">
    <div class="col-sm-12" style="background-color: #f2f2f2">
      <button pButton type="button" class="btn btn-secondary" (click)="addRow()">Add a Row</button>
    </div>
  </div>
</div>
<div [hidden]="!showFormulaField" class="p-15">
  <div>
    <textarea class="w-100" rows="10" pInputTextarea [(ngModel)]="arcFormula.Formula"></textarea>
  </div>
</div>
<div class="form-group col-sm-12" style="margin-top: 20px">
  <div class="pull-right">
    <button pButton (click)="cancel()" class="atlas-btn atlas-btn-secondary tall-36 mr-10" icon="pi pi-ban">
      {{ 'common.cancel' | translate | uppercase }}
    </button>
    <button pButton (click)="saveArc()" class="atlas-btn atlas-btn-primary tall-36" icon="pi pi-save">
      {{ 'common.save' | translate | uppercase }}
    </button>
  </div>
</div>
